import useSWR from 'swr';
import { surveyService } from '@/services/api';
import { config } from '@/config';
import { AwaitedReturnType, FetchErrorsType } from '@/types';
import { useRouter } from '@/hooks/general/useRouter/useRouter';

const API_URL = config.api.url.survey;

export const useSurveysQuery = (
    offset: number,
    limit: number,
    userId?: string,
    surveyKey?: string,
    disableRedirects?: boolean,
    reCaching?: boolean,
) =>
    useSWR<AwaitedReturnType<typeof surveyService.getSurveys>, FetchErrorsType>(
        [`${API_URL}`, offset, limit, userId, surveyKey],
        () =>
            surveyService.getSurveys(offset, limit, userId, surveyKey, reCaching, disableRedirects),
        {
            revalidateOnMount: true,
            revalidateOnFocus: false,
        },
    );

export const useSurveyHistoryQuery = (year: string | number) => {
    const router = useRouter();
    return useSWR([`${API_URL}`, year], () =>
        surveyService.getSurveyHistory(Number(year), { routerPush: router.push }),
    );
};

export const useContinueSurveyQuery = (
    surveyKey: string | undefined,
    userId: string | undefined,
) => {
    return useSWR<AwaitedReturnType<typeof surveyService.continueSurvey>, FetchErrorsType>(
        surveyKey && userId ? [`${API_URL}`, surveyKey, userId] : null,
        () => surveyService.continueSurvey(surveyKey as string, userId as string),
    );
};
